import React, { useContext, useState } from 'react';
import {
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    IconButton,
    Box,
    Collapse,
    useTheme,
    useMediaQuery,
    SvgIcon,
    Avatar,
    Stack,
    Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import MarkChatUnreadIcon from '@mui/icons-material/MarkChatUnread';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import QuizIcon from '@mui/icons-material/Quiz';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import GroupIcon from '@mui/icons-material/Group';
import { useNavigate } from 'react-router-dom';
import GameonLogo from '../../assets/images/gameup_white.png';
import Placeholder from '../../assets/images/avatar_xp_placeholder.png';
import { UserContext } from '../../contexts/UserContext';
import { AuthContext } from '../../contexts/AuthContext';

const drawerWidth = 300;

const Sidebar = () => {
    const [openSubMenus, setOpenSubMenus] = useState({});
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const navigate = useNavigate();
    const theme = useTheme();
    const { user, clearUser } = useContext(UserContext);
    const { logout } = useContext(AuthContext);
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));

    const toggleDrawer = () => setIsDrawerOpen((prev) => !prev);
    const toggleSubMenu = (index) => {
        setOpenSubMenus((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const menuItems = [
        { path: '/dashboard/home', label: 'Início', icon: <HomeIcon /> },
        {
            label: 'Definições',
            icon: <AssignmentOutlinedIcon />,
            subItems: [
                { path: '/dashboard/players/list', label: 'Jogadores' },
                {
                    path: '/dashboard/players/cards',
                    label: 'Cartões de Acesso',
                },
                { path: '/dashboard/players/groups', label: 'Grupos' },
                { path: '/dashboard/players/games', label: 'Jogos' },
            ],
        },
        {
            label: 'Missões',
            icon: <AssignmentOutlinedIcon />,
            subItems: [
                { path: '/dashboard/contents/manage', label: 'Gerenciar' },
                { path: '/dashboard/contents/requests', label: 'Aprovar' },
                { path: '/dashboard/contents/history', label: 'Histórico' },
            ],
        },
        // {
        //     label: 'Desafios',
        //     icon: <AssignmentOutlinedIcon />,
        //     subItems: [
        //         { path: '/dashboard/challange/manage', label: 'Gerenciar' },
        //         { path: '/dashboard/challange/challanger', label: 'Aprovar' },
        //     ],
        // },
        {
            label: 'Quiz',
            icon: <QuizIcon />,
            subItems: [
                { path: '/dashboard/quiz/manage', label: 'Gerenciar' },
                { path: '/dashboard/quiz/history', label: 'Histórico' },
            ],
        },
        {
            label: 'Loja',
            icon: <LocalMallOutlinedIcon />,
            subItems: [
                { path: '/dashboard/store/products', label: 'Recompensas' },
                { path: '/dashboard/store/purchases', label: 'Pedidos' },
                { path: '/dashboard/store/history', label: 'Histórico' },
            ],
        },
        {
            label: 'Eventos',
            icon: <InsertInvitationIcon />,
            path: '/dashboard/events/manage',
        },
        {
            label: 'Mensagens',
            icon: <MarkChatUnreadIcon />,
            path: '/dashboard/messages',
        },
        {
            path: '/dashboard/settings',
            label: 'Configurações',
            icon: <SettingsOutlinedIcon />,
        },
    ];

    return (
        <>
            {!isLargeScreen && (
                <Box
                    sx={{
                        width: '100%',
                        backgroundColor: '#1F83FF',
                        height: '60px',
                        padding: '10px 20px',
                    }}
                >
                    <Stack
                        direction='row'
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <img
                            src={GameonLogo}
                            alt='Logo'
                            style={{
                                width: '128px',
                                height: 'auto',
                            }}
                        />
                        <IconButton color='#FFFFFF' onClick={toggleDrawer}>
                            <MenuIcon
                                sx={{
                                    color: '#FFFFFF',
                                }}
                            />
                        </IconButton>
                    </Stack>
                </Box>
            )}

            <Drawer
                variant={isLargeScreen ? 'permanent' : 'temporary'}
                open={isLargeScreen ? true : isDrawerOpen}
                onClose={toggleDrawer}
                ModalProps={{
                    keepMounted: true,
                }}
                sx={{
                    width: isLargeScreen ? drawerWidth : undefined,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        backgroundColor: theme.palette.primary.main,
                    },
                }}
            >
                <Box sx={{ width: drawerWidth }} role='presentation'>
                    {isLargeScreen && (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: 15,
                            }}
                        >
                            <img
                                src={GameonLogo}
                                alt='Logo'
                                style={{
                                    width: '128px',
                                    height: 'auto',
                                }}
                            />
                        </Box>
                    )}

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginTop: 2,
                        }}
                    >
                        <Stack direction='row' spacing={2} alignItems='center'>
                            <Avatar
                                alt='user image'
                                src={user.photo ? user.photo : Placeholder}
                                sx={{
                                    width: 56,
                                    height: 56,
                                }}
                            />
                            <Stack direction='column' alignItems='center'>
                                <Typography
                                    sx={{
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        color: theme.palette.primary
                                            .contrastText,
                                    }}
                                >
                                    {user.name}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: '14px',
                                        color: theme.palette.primary
                                            .contrastText,
                                    }}
                                >
                                    Administrador
                                </Typography>
                            </Stack>
                        </Stack>
                    </Box>

                    <List
                        sx={{
                            mr: 4,
                            ml: 4,
                        }}
                    >
                        {menuItems.map((item, index) => (
                            <React.Fragment key={index}>
                                {!item.subItems ? (
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            onClick={() => {
                                                navigate(item.path);
                                                if (!isLargeScreen) {
                                                    toggleDrawer();
                                                }
                                            }}
                                            sx={{
                                                borderRadius: '12px',
                                                backgroundColor:
                                                    window.location.pathname ===
                                                    item.path
                                                        ? theme.palette.primary
                                                              .light
                                                        : 'transparent',
                                                '&:hover': {
                                                    backgroundColor:
                                                        theme.palette.primary
                                                            .dark,
                                                },
                                                '&.Mui-selected': {
                                                    backgroundColor:
                                                        theme.palette
                                                            .blueDark[200],
                                                    '&:hover': {
                                                        backgroundColor:
                                                            theme.palette
                                                                .blueDark[100],
                                                    },
                                                },
                                            }}
                                            selected={
                                                window.location.pathname ===
                                                item.path
                                            }
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    color:
                                                        window.location
                                                            .pathname ===
                                                        item.path
                                                            ? theme.palette
                                                                  .primary
                                                                  .contrastText
                                                            : theme.palette
                                                                  .primary
                                                                  .contrastText,
                                                }}
                                            >
                                                {item.icon}
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={item.label}
                                                sx={{
                                                    color:
                                                        window.location
                                                            .pathname ===
                                                        item.path
                                                            ? theme.palette
                                                                  .primary
                                                                  .contrastText
                                                            : theme.palette
                                                                  .primary
                                                                  .contrastText,
                                                }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                ) : (
                                    <>
                                        <ListItem disablePadding>
                                            <ListItemButton
                                                onClick={() =>
                                                    toggleSubMenu(index)
                                                }
                                                sx={{ borderRadius: '12px' }}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        color: theme.palette
                                                            .primary
                                                            .contrastText,
                                                    }}
                                                >
                                                    {item.icon}
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={item.label}
                                                    sx={{
                                                        color: theme.palette
                                                            .primary
                                                            .contrastText,
                                                    }}
                                                />
                                                {openSubMenus[index] ? (
                                                    <ExpandLess
                                                        sx={{
                                                            color: theme.palette
                                                                .primary
                                                                .contrastText,
                                                        }}
                                                    />
                                                ) : (
                                                    <ExpandMore
                                                        sx={{
                                                            color: theme.palette
                                                                .primary
                                                                .contrastText,
                                                        }}
                                                    />
                                                )}
                                            </ListItemButton>
                                        </ListItem>
                                        <Collapse
                                            in={openSubMenus[index]}
                                            timeout='auto'
                                            unmountOnExit
                                        >
                                            <List
                                                component='div'
                                                disablePadding
                                            >
                                                {item.subItems.map(
                                                    (subItem, subIndex) => (
                                                        <ListItem
                                                            key={subIndex}
                                                            disablePadding
                                                        >
                                                            <ListItemButton
                                                                sx={{
                                                                    pl: 4,
                                                                    borderRadius:
                                                                        '12px',
                                                                    color: theme
                                                                        .palette
                                                                        .primary
                                                                        .contrastText,
                                                                    backgroundColor:
                                                                        window
                                                                            .location
                                                                            .pathname ===
                                                                        subItem.path
                                                                            ? theme
                                                                                  .palette
                                                                                  .blueDark[200]
                                                                            : 'transparent',
                                                                    '&:hover': {
                                                                        backgroundColor:
                                                                            theme
                                                                                .palette
                                                                                .blueDark[100],
                                                                    },
                                                                }}
                                                                onClick={() => {
                                                                    navigate(
                                                                        subItem.path
                                                                    );
                                                                    if (
                                                                        !isLargeScreen
                                                                    ) {
                                                                        toggleDrawer();
                                                                    }
                                                                }}
                                                            >
                                                                <ListItemText
                                                                    primary={
                                                                        subItem.label
                                                                    }
                                                                    sx={{
                                                                        color: theme
                                                                            .palette
                                                                            .primary
                                                                            .contrastText,
                                                                    }}
                                                                />
                                                            </ListItemButton>
                                                        </ListItem>
                                                    )
                                                )}
                                            </List>
                                        </Collapse>
                                    </>
                                )}
                            </React.Fragment>
                        ))}
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    logout();
                                    clearUser();
                                }}
                                sx={{
                                    borderRadius: '12px',
                                    '&:hover': {
                                        backgroundColor:
                                            theme.palette.primary.dark,
                                    },
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        color: theme.palette.primary
                                            .contrastText,
                                    }}
                                >
                                    <ExitToAppIcon />
                                </ListItemIcon>
                                <ListItemText
                                    primary='Sair'
                                    sx={{
                                        color: theme.palette.primary
                                            .contrastText,
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
        </>
    );
};

export default Sidebar;
